<template>
  <div class="upload-attachment">
    <v-divider class="my-8" />

    <h4 class="mb-2">
      {{ $t('appointment.formCreate.titles.attachments') }}
    </h4>
    <p class="body-2 grey--text mb-4">
      {{ $t('appointment.formCreate.labels.attachmentsHint') }}
    </p>

    <div v-if="isAttachmentUploadSuccessful" class="success-wrapper mw-300 mx-auto">
      <HSuccess />
      <h2 class="grey--text text-center">
        {{ $t('appointment.formCreate.titles.attachmentsUploaded') }}
      </h2>
    </div>

    <HUploading v-if="isAppointmentFilesUploading" />

    <HUpload
      @change="handleGetFiles"
      :loading="isAppointmentFilesUploading"
      fileTypes="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ref="attachmentUploader"
      small
    />
    <p v-if="!hasAttachment" class="mt-n5 caption text-center red--text">
      {{ $t('rules.attachment') }}
    </p>
  </div>
</template>

<script>
import HUpload from '@/components/lib/HUpload'
import HSuccess from '@/components/app/HSuccess'
import HUploading from '@/components/app/HUploading'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'UploadAttachment',

  components: {
    HUploading,
    HSuccess,
    HUpload,
  },

  computed: {
    ...mapGetters([
      'hasAttachment',
      'isAttachmentUploadSuccessful',
      'isAppointmentFilesUploading',
    ]),
  },

  methods: {
    ...mapActions(['attachAppointmentAttachment']),

    handleGetFiles(files) {
      this.attachAppointmentAttachment({ files })
    },

    resetUploadField() {
      this.$refs.attachmentUploader?.resetUploadField()
    },
  },
}
</script>

<style scoped>
.success-wrapper .success-animation {
  margin: 0;
  transform: scale(0.75);
}
</style>
